import colors from 'src/theme/colors';
import { defineRecipe } from '@chakra-ui/react';
import fonts from '../fonts';

const Input = defineRecipe({
  base: {
    color: 'podcastShade500',
    fontFamily: fonts.normal,
    boxShadow: 'inset 0px -3px 10px rgba(205, 204, 227, 0.2)',
    borderRadius: 12,
    _placeholder: {
      color: 'podcastShade500',
      opacity: '0.5',
    },
  },
  variants: {
    visual: {
      primary: {
        bgColor: 'white',
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: 'podcastShade300',
        borderRadius: '12px',
        outlineOffset: 0,
        _hover: {
          boxShadow: 'none',
        },
        _focusWithin: {
          borderColor: 'podcastPurple',
          outlineWidth: '1px',
          outlineStyle: 'solid',
          outlineColor: 'podcastPurple',
          _invalid: {
            borderColor: 'podcastRed400',
            outlineWidth: '1px',
            outlineColor: 'podcastRed400',
          },
        },
        _invalid: {
          border: `1px solid ${colors.podcastRed400}`,
          boxShadow: 'inset 0px -3px 6px rgba(239, 57, 113, 0.05)',
        },
      },
      labelInsideInput: {
        position: 'absolute',
        border: 'none',
        boxShadow: 'none',
        borderRadius: 0,
        background: 'none',
        top: '26px',
        p: 0,
        w: 'calc(100% - 40px)',
        ml: '20px',
        h: '30px',
        _focus: {
          outline: 'none',
        },
      },
    },
    size: {
      small: {
        height: '36px',
        fontSize: '13px',
      },
      large: {
        height: '48px',
        padding: '20px',
        fontSize: '16px',
      },
    },
  },
  defaultVariants: {
    visual: 'primary',
    size: 'large',
  },
});

export default Input;
